const theNormalModalStyle = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxHeight: '95%'
  }
}

export const smallModalStyle = {
  content: { ...theNormalModalStyle.content, width: '60%' }
}
export const normalModalStyle = theNormalModalStyle
